
























import type { ComputedRef, PropType } from '@vue/composition-api';
import { computed, watch, ref, defineComponent } from '@vue/composition-api';
import type { EditorBlock } from '@getaccept/editor-lib';
import { ContractHelper } from '@getaccept/editor-lib';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { DocumentRecipientRevision } from '@getaccept/lib-shared/src/types/document-revision';
import SectionList from './SectionList.vue';

export default defineComponent({
  name: 'BlockListItem',
  components: {
    SectionList,
    NameInput,
  },
  props: {
    block: {
      type: Object as PropType<EditorBlock>,
      required: true,
    },
    isCurrentBlock: {
      type: Boolean,
      default: false,
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: null,
    },
    latestViewedRevision: {
      type: Object as PropType<DocumentRecipientRevision>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const sectionsOpen = ref(false);
    const nameInputValue = ref(props.block.content.displayName || t('untitled_page'));
    const viewed = ref(false);
    const hasContentBeenViewed: ComputedRef<boolean> = computed(() => {
      const found = props?.latestViewedRevision.editorBlockContentVersions.find(
        revision =>
          revision.contentId === props.block.contentVersion && revision.blockId === props.block.id
      );
      return found ? true : false;
    });

    watch(
      () => props?.latestViewedRevision.editorBlockContentVersions,
      () => {
        viewed.value = hasContentBeenViewed.value;
      },
      { immediate: true, deep: true }
    );

    watch(
      () => props.isCurrentBlock,
      () => {
        if (props.isCurrentBlock) {
          sectionsOpen.value = true;
          setTimeout(() => (viewed.value = true), 1000);
        }
      },
      { immediate: true }
    );

    const toggleSections = () => {
      sectionsOpen.value = !sectionsOpen.value;
    };

    const filteredSections = computed(() =>
      ContractHelper.filterSectionsByContractLinkAccess(
        props.block.content.sections,
        props.recipient
      )
    );

    const navigateToSection = event => {
      emit('navigate-to-section', event);
      setTimeout(() => (viewed.value = true), 1000);
    };

    const visibleSections = computed(() => filteredSections.value.filter(({ hidden }) => !hidden));

    return {
      sectionsOpen,
      toggleSections,
      nameInputValue,
      visibleSections,
      filteredSections,
      navigateToSection,
      hasContentBeenViewed,
      viewed,
    };
  },
});
